import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ChooseInterestComponent } from './choose-interest/choose-interest.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
// import { OtpVarificationComponent } from './otp-varification/otp-varification.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignupComponent } from './signup/signup.component';
import { RouteConstant } from '../core/_constants/route.constant';
// import {EmailOtpVarificationComponent} from './email-otp-varification/email-otp-varification.component'
import { PhoneOtpVarificationComponent } from './phone-otp-varification/phone-otp-varification.component'
import { AuthGuard } from '../core/_constants/guards/auth.guard';
import { backButtonGuard } from '../core/_constants/guards/back-button.guard';
import { PhoneAuthGuard } from '../core/_constants/guards/phone-otp.guard';
import { BlogsComponent } from './blogs/blogs.component';
import { AddMachineComponent } from '../modules/pages/profile/my-listings/add-machine/add-machine.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';
import { TermofuseComponent } from './termofuse/termofuse.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { LicenseComponent } from './license/license.component';
import { PatnerWithUsComponent } from './patner-with-us/patner-with-us.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { UserEnquiriesComponent } from './user-enquiries/user-enquiries.component';


const routes: Routes = [

  {
    path: '',
    redirectTo: '/mainhome',
    pathMatch: 'full'
  },

  {
    path: RouteConstant.Login,
    component: LoginComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: RouteConstant.chooseInterest,
    component: ChooseInterestComponent,
    // canActivate:[AuthGuard]
  },
  {
    path: RouteConstant.forgotPassword,
    component: ForgotPasswordComponent,
    // canActivate:[AuthGuard]
  },
  // {
  //   path:RouteConstant.otpVarification,
  //   component:OtpVarificationComponent
  // },
  {
    path: RouteConstant.resetPassword,
    component: ResetPasswordComponent,
    // canActivate:[AuthGuard]
  },
  {
    path: RouteConstant.Signup,
    component: SignupComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: RouteConstant.UserRegistration,
    component: UserRegistrationComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: RouteConstant.UserEnquiry,
    component: UserEnquiriesComponent,
    // canActivate: [AuthGuard]
  },
  // {
  //   path:'email-otp',
  //   component:EmailOtpVarificationComponent
  // },
  {
    path: RouteConstant.PhoneOtp,
    component: PhoneOtpVarificationComponent,
    // canActivate: [PhoneAuthGuard]
    // canDeactivate: [CanDeactivateGuard],
  },
  {
    path: RouteConstant.blogs,
    component: BlogsComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: RouteConstant.termsofuse,
    component: TermofuseComponent,
  },
    {
    path: RouteConstant.privacypolicy,
    component: PrivacypolicyComponent
  },
  {
      path:RouteConstant.Patnerwithus,
      component:PatnerWithUsComponent
    },
  {
    path: RouteConstant.aboutUs,
    component: AboutusComponent,
  },
  {
    path: RouteConstant.license,
    component: LicenseComponent,
  },
  //  { path: `${RouteConstant.blogs}/:id`, component: BlogDetailComponent }, 
  { path: `${RouteConstant.blogs}/:alias`, component: BlogDetailComponent }, 

  {
    path: RouteConstant.addmachine,
    component: AddMachineComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
